import { TemplateResult } from 'lit';

export enum DownloadType {
  CSV = 'csv',
  PDF = 'pdf',
  XLSX = 'xlsx'
}

export interface Downloader {
  download(headers: string[]|TemplateResult[], rows: string[][]|TemplateResult[][]): void;
}
